export default __webpack_public_path__ + "static/media/one-9.f17b4f02.jpg";